// Import the parent so its module fully evaluates before we assign .Item.
// (ES module imports are hoisted and execute synchronously before this file's body.)
import { TestId } from "#/test-ids";

import "../items_list.js";

window.Sparkle ??= {};
window.Sparkle.Spotlight ??= {};
window.Sparkle.Spotlight.ItemsList ??= {};

Sparkle.Spotlight.ItemsList.Item = class Item {
  constructor(data, showIdentifier, options) {
    this.render = this.render.bind(this);
    this.accessibleName = this.accessibleName.bind(this);
    this._textOf = this._textOf.bind(this);
    this.setHighlight = this.setHighlight.bind(this);
    this.data = data;
    this.showIdentifier = showIdentifier;
    if (options == null) {
      options = {};
    }
    this.options = options;
    this.el = jQuery('<div class="spotlight-items-list-item" role="listitem">');
    this.el.attr("data-testid", TestId.spotlight.item);
    this.el.attr({ title: this.data.typeName });
  }

  render() {
    this.el.attr("data-item-type", this.data.type);
    this.el.attr("aria-label", this.accessibleName());
    this.el.empty();
    if (this.data.icon) {
      this.el.append(jQuery('<img class="item-icon">').attr({ src: this.data.icon }));
    }
    this.el.append(jQuery('<span class="item-name">').html(this.data.name));
    if (this.showIdentifier && this.data.identifier) {
      this.el.append(jQuery('<span class="item-identifier">').html(this.data.identifier.replace(/\n/g, "<br>")));
    }

    return this;
  }

  // HELPER FUNCTIONS

  // An aria-label overrides the text inside the item, so the identifier below the name reaches a
  // screen reader only by being part of the label. Either may carry markup around the portions
  // matching the query by the time it arrives here, so both are read back as text.
  accessibleName() {
    const parts = [this._textOf(this.data.name)];
    if (this.showIdentifier && this.data.identifier) {
      parts.push(this._textOf(this.data.identifier));
    }
    return parts.join(", ");
  }

  _textOf(html) {
    return jQuery("<div>").html(html).text();
  }

  setHighlight(state) {
    if (state) {
      if (this.el.hasClass("highlight")) {
        return;
      }
      return this.el.addClass("highlight");
    } else {
      if (!this.el.hasClass("highlight")) {
        return;
      }
      return this.el.removeClass("highlight");
    }
  }
};
